import React, { Component } from 'react';

// Components
import AddSponsor from '../component/AddSponsor';
import AdvertiesSponsor from '../component/AdvertiesSponsor'
import ScheduleAds from './ScheduleAds';
import PlusIcon from '../icons/plusicon';

class AddSponsors extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [
                {
                  label: "Footer Sponsors",
                  Content: ""
                },
                {
                  label: "Advertiesment Sponsors",
                  Content: ""
                },
                { label: "Schedule Ads", Content: "" }
            ],
            activetab: 0,
        }
        this.scheduleAdsRef = React.createRef();
    }

    TabClick = index => {
        this.setState({
          activetab: index
        });
    };

    render() {
        const { activetab } = this.state;
        return (
            <React.Fragment>
                    <div className="right_side_wrapper add_sponsors_section">
                        <ul className="fpg_admin_tab disp_flex small_list_tab">
                            {this.state.data && this.state.data.map((list, index) => {
                                const isScheduleAdsActive = list.label === 'Schedule Ads' && activetab === index;
                                return (
                                <li
                                    key={index}
                                    className={activetab === index ? "active" : ""}
                                    onClick={() => this.TabClick(index)}
                                >
                                    <p className="uppercase">
                                        <div style={{ width: isScheduleAdsActive ? 'calc(100% - 58px)' : '100%' }}>
                                            {list.label}
                                        </div>
                                        {isScheduleAdsActive && (
                                            <span
                                                className="add_icon d_flex"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.scheduleAdsRef.current && this.scheduleAdsRef.current.openAddPopup();
                                                }}
                                            >
                                                <PlusIcon />
                                            </span>
                                        )}
                                    </p>
                                </li>
                                );
                            })}
                        </ul>

                        <div className="dashboard_data" style={{height: activetab === 2 ? 'auto' : 'calc(100vh - 136px)'}}>
                            {activetab === 0 &&
                                <div className="add_sponsors_wpr">
                                    <AddSponsor />
                                </div>
                            }
                            {activetab === 1 && <AdvertiesSponsor />}
                            {activetab === 2 && <ScheduleAds ref={this.scheduleAdsRef} />}
                        </div>


                    </div>
            </React.Fragment>
        )
    }
}

export default AddSponsors;
